import { hhmmADoMMMYYYY, formatMs } from '@fareye/utils'
import React from 'react'
import { L, Marker, Popup, useMap } from '@fareye/ui'
import { displayTime } from '../../utility/function'
// import { Stoppage } from '../../utils/types'
import { useTranslation } from '@fareye/common'

interface StoppageMarkerProps {
  iconUrl: string
  iconSize: any
  stoppage: any
  selected: boolean
  type?: string
}

export function StoppageMarker({
  iconUrl,
  iconSize,
  stoppage,
  selected,
  type = ''
}: StoppageMarkerProps) {
  const { t } = useTranslation()
  const map = useMap()
  let ref = React.useRef(null)
  const [state, setState] = React.useState(0)
  const startTime =
    type === 'UTC'
      ? displayTime(stoppage.startTimestampUtc)
      : hhmmADoMMMYYYY(stoppage.startTimestamp)
  const endTime =
    type === 'UTC'
      ? displayTime(stoppage.endTimestampUtc)
      : hhmmADoMMMYYYY(stoppage.endTimestamp)
  React.useEffect(() => {
    if (selected && ref) {
      map.openPopup(ref.current as any)
      setState(state + 1)
    }
  }, [selected])
  if (selected){
    map.setView(L.latLng(stoppage.startLat, stoppage.startLong), 13)
    map.setView(L.latLng(stoppage.startLat, stoppage.startLong), 12)
  }
  return (
    <Marker
      position={L.latLng(stoppage.startLat, stoppage.startLong)}
      icon={
        new L.Icon({
          iconUrl,
          iconSize,
          iconAnchor: [5, 10]
        })
      }
      // ref={el => openPopup(el)}
      eventHandlers={{ click: () => setState(state + 1) }}
    >
      <Popup minWidth={149} ref={ref}>
        <h5>
          <strong>{t('Stoppage Details')} :</strong>
        </h5>
        <strong>{t('Landmark')}</strong>: {stoppage.startLandmark}
        <br />
        <strong>{t('Time')}</strong>: {`${startTime} ${t('to')} ${endTime}`}
        <br />
        <strong>{t('Duration')}</strong>:{formatMs(stoppage.duration * 1000)}
      </Popup>
    </Marker>
  )
}
